// Name to upload a staged {file, name} with — keeps the original extension if the user dropped it.
export function stagedName({ file, name }) {
  const n = (name || "").trim() || file.name;
  const dot = file.name.lastIndexOf(".");
  const ext = dot > 0 ? file.name.slice(dot) : "";
  return ext && !n.toLowerCase().endsWith(ext.toLowerCase()) ? n + ext : n;
}
